import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Location } from '../models';
import { LocationConfigService } from './location-config.service';
import { BASE_URL } from '@teamfoster/sdk/ssr';
@Injectable()
export class LocationService {
  private http = inject(HttpClient);
  private BASE_URL = inject(BASE_URL, { optional: true });
  private config = inject(LocationConfigService);

  public location: { [identifier: string]: Location } = {};

  private get _apiUrl() {
    if (!this.config.apiUrl) return `${this.BASE_URL || ''}api/locations`;
    if (this.isAbsolute(this.config.apiUrl)) {
      return this.config.apiUrl;
    }

    return `${this.BASE_URL || ''}${this.config.apiUrl}`;
  }

  loadLocations() {
    return this.http.get<Location[]>(this._apiUrl);
  }

  init() {}

  isAbsolute(url: string) {
    var pattern = /^https?:\/\//i;
    return pattern.test(url);
  }
}
